export default __webpack_public_path__ + "static/media/hamburger-menu-outline-16px-blue.86e42fc9.svg";